import { useMemo } from 'react';
import { useDynamicData, useStaticData } from '../contexts/DataProvider.context';
import { Product } from '../types/product.types';
import { getProductAvailability } from '../utils/helper';
import { mergeAfcStoreCodes } from '../utils/storeCodes';

export function useProductAvailability(
  product: Product,
  isExpressDeliveryOverride?: boolean,
  hasAlcoholProductAvailability?: boolean,
) {
  const { currentStoreCodes, expressStoreCodes, afcStoreCodes, isAfcStoreEnabled, alcoholExpiryDate, countryCode } =
    useStaticData();
  const { isExpressDelivery } = useDynamicData();
  const shouldCheckExpress = isExpressDeliveryOverride ?? isExpressDelivery;
  const hasExpressCodes = expressStoreCodes?.length > 0;
  const hasCurrentCodes = currentStoreCodes?.length > 0;

  const storeCodes = useMemo(() => {
    const baseStoreCodes =
      shouldCheckExpress && hasExpressCodes ? expressStoreCodes : hasCurrentCodes ? currentStoreCodes : [];

    return mergeAfcStoreCodes(baseStoreCodes, afcStoreCodes, isAfcStoreEnabled);
  }, [
    afcStoreCodes,
    currentStoreCodes,
    expressStoreCodes,
    hasCurrentCodes,
    hasExpressCodes,
    isAfcStoreEnabled,
    shouldCheckExpress,
  ]);

  return useMemo(() => {
    return getProductAvailability(
      product,
      storeCodes,
      {
        alcoholExpiryDate: alcoholExpiryDate,
      },
      shouldCheckExpress,
      undefined,
      countryCode,
      hasAlcoholProductAvailability,
    );
  }, [storeCodes, product, alcoholExpiryDate, countryCode, shouldCheckExpress, hasAlcoholProductAvailability]);
}
